define('bindingHandlers/agentInfoTable',[
    'lib/knockout',
    'jquery',
    'lib/lodash4',
    'viewModels/widgets/Pager',
    'util/externalInclude'
], function (
    ko,
    $,
    _,
    Pager,
    include
) {
    'use strict';

    function buildFooterTemplate () {
        var $footerTemplate = $('.data-table').find("[data-footer]").addClass("table-controls").addClass("footer-controls");

        var $footerContent = $("<div class=\"control-section\">");

        $footerContent.append("<div class=\"loading load-indicator-sm\" data-bind=\"loadIndicator: isLoadingRows\">");
        $footerContent.append("<div data-bind=\"include: { name: 'templates/widgets/pager', data: pager }\">");

        $footerTemplate.append($footerContent);

        return $footerContent[0];
    }

    var pagerViewModel = new Pager();

    ko.bindingHandlers.agentInfoTable = {
        init: function (element, valueAccessor) {
            var params = ko.unwrap(valueAccessor());

            pagerViewModel.pageCount = params.pageCount;
            pagerViewModel.pageNumber = params.pageNumber;
            pagerViewModel.pageSize = params.pageSize;

            var optionsChangeListener = ko.multiSubscribe(
                [ pagerViewModel.pageSize, pagerViewModel.pageNumber ],
                params.onDataOptionsChange.bind(null, this, false)
            );

            var setDisplayedPageNumber = function () {
                pagerViewModel.displayedPageNumber(params.pageNumber());
            };

            params.pageNumber.subscribe(setDisplayedPageNumber);

            var noRowsSelected = ko.computed(function () {
                return _.intersectionBy(params.selectedRows(), params.rows(), 'id').length === 0;
            });

            var allRowsSelected = ko.computed(function () {
                return _.intersectionBy(params.selectedRows(), params.rows(), 'id').length === params.rows().length;
            });

            var partialRowsSelected = ko.computed(function () {
                return !noRowsSelected() && !allRowsSelected();
            });

            var onToggleAllRowSelection = function() {
                if (!noRowsSelected()) {
                    var visibleRowIds = params.rows().map(function(row) {
                        return row.id;
                    });
                    params.selectedRows.remove(function(selectedRow) {
                        return visibleRowIds.includes(selectedRow.id);
                    });
                } else {
                    params.selectedRows.push.apply(params.selectedRows, params.rows());
                }
            };

            var isSelectedRow = function(row) {
                return params.selectedRows().some(function(selectedRow) {
                    return selectedRow.id === row.id;
                });
            };

            var toggleRowSelected = function(row) {
                if (isSelectedRow(row)) {
                    params.selectedRows.remove(function(selectedRow) {
                        return selectedRow.id === row.id;
                    });
                } else {
                    params.selectedRows.push(row);
                }
            };

            var dataTableProps = {
                rows: params.rows,
                columns: params.columns,
                selectedRows: params.selectedRows,
                noRowsSelected: noRowsSelected,
                allRowsSelected: allRowsSelected,
                partialRowsSelected: partialRowsSelected,
                onToggleAllRowSelection: onToggleAllRowSelection,
                isSelectedRow: isSelectedRow,
                toggleRowSelected: toggleRowSelected
            };

            include.loadTemplate('templates/widgets/agentInfoTable').then(function () {
                ko.renderTemplate('templates/widgets/agentInfoTable', dataTableProps, { }, element);
                ko.applyBindings({
                    isLoadingRows: params.isLoadingRows,
                    pager: pagerViewModel
                }, buildFooterTemplate());
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                optionsChangeListener.dispose();
            });
        }
    };
});

